export const messages = {
  consumptionLinkText: {
    id: 'nemo.ui.sc.tiles.consumption.link.text',
    defaultMessage: 'consmuption data',
  },
  fuelType: {
    other: {
      id: 'nemo.ui.sc.eec.fuel.a',
      defaultMessage: 'Other',
    },
    petrol: {
      id: 'nemo.ui.sc.eec.fuel.b',
      defaultMessage: 'Petrol',
    },
    diesel: {
      id: 'nemo.ui.sc.eec.fuel.d',
      defaultMessage: 'Petrol',
    },
    electric: {
      id: 'nemo.ui.sc.eec.fuel.e',
      defaultMessage: 'Electric',
    },
    gas: {
      id: 'nemo.ui.sc.eec.fuel.f',
      defaultMessage: 'Electric',
    },
    benzinGas: {
      id: 'nemo.ui.sc.eec.fuel.g',
      defaultMessage: 'Electric',
    },
    benzinElect: {
      id: 'nemo.ui.sc.eec.fuel.h',
      defaultMessage: 'Electric',
    },
    dieselGas: {
      id: 'nemo.ui.sc.eec.fuel.i',
      defaultMessage: 'Electric',
    },
    dieselElect: {
      id: 'nemo.ui.sc.eec.fuel.j',
      defaultMessage: 'diesel electric',
    },
    autogas: {
      id: 'nemo.ui.sc.eec.fuel.k',
      defaultMessage: 'autogas',
    },
    erdgas: {
      id: 'nemo.ui.sc.eec.fuel.l',
      defaultMessage: 'Electric',
    },
    ethanol: {
      id: 'nemo.ui.sc.eec.fuel.m',
      defaultMessage: 'ethanol',
    },
    wassers: {
      id: 'nemo.ui.sc.eec.fuel.n',
      defaultMessage: 'wassers',
    },
  },
  warrantyYes: { id: 'nemo.ui.sc.highlights.warranty.yes', defaultMessage: 'Yes' },
  warrantyLabel: { id: 'nemo.ui.sc.highlights.warranty.label', defaultMessage: 'Warranty' },
  availableSoon: { id: 'nemo.ui.sc.available.soon.fallback.text', defaultMessage: 'Soon' },
  availableSoonMileage: { id: 'nemo.ui.sc.available.now.mileage', defaultMessage: '' },
  usedCarMileage: {
    id: 'nemo.ui.sc.available.soon.mileage',
    defaultMessage: 'voraussichtliche Kilometer',
  },
  vehiclePreuseDescription: {
    'demonstration-car': {
      id: 'nemo.ui.sc.vehicle-preuse.demonstration-car',
      defaultMessage: 'Demonstration car',
    },
    'one-year-car': {
      id: 'nemo.ui.sc.vehicle-preuse.one-year-car',
      defaultMessage: 'One year car',
    },
    'company-car': { id: 'nemo.ui.sc.vehicle-preuse.company-car', defaultMessage: 'Company car' },
    'used-car': { id: 'nemo.ui.sc.vehicle-preuse.used-car', defaultMessage: 'Used car' },
    none: { id: '', defaultMessage: '' },
  },
  consumptionCombinedLabel: {
    id: 'nemo.ui.sc.consumption.combined.label',
    defaultMessage: 'combined',
  },
  emissionCombinedLabel: { id: 'nemo.ui.sc.emission.combined.label', defaultMessage: 'combined' },
};
